import type { SVGProps } from 'react';
import { memo } from 'react';

import { SVG_STOROKE_SIZE } from '@/data/shared/constant';

import { IconSizeType } from '@/types/icon';

interface SvgIconProps extends SVGProps<SVGSVGElement> {
  size: IconSizeType;
}
const SvgIconStarRoundLine = ({ size = 24, ...props }: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 25 24"
    className="svgr-icon-component"
    strokeWidth={SVG_STOROKE_SIZE[size]}
    {...props}
  >
    <path
      stroke="currentColor"
      d="M11.561 5.316a.5.5 0 0 1 .904 0l1.78 3.756a.5.5 0 0 0 .378.28l4.014.607a.5.5 0 0 1 .282.846l-2.93 2.973a.5.5 0 0 0-.138.432l.689 4.176a.5.5 0 0 1-.734.52l-3.553-1.944a.5.5 0 0 0-.48 0L8.22 18.906a.5.5 0 0 1-.734-.52l.688-4.176a.5.5 0 0 0-.137-.433l-2.93-2.972a.5.5 0 0 1 .281-.846l4.015-.607a.5.5 0 0 0 .377-.28l1.781-3.756Z"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
const Memo = memo(SvgIconStarRoundLine);
export default Memo;
